import React, { useEffect, useRef } from 'react';
import './Popup.css';

interface IcerikPopupProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  content?: string;
}

const IcerikPopup: React.FC<IcerikPopupProps> = ({ isOpen, onClose, title, content }) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isOpen) {
      closeButtonRef.current?.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div id="popup_icerik" className={`popup-overlay ${isOpen ? 'open' : ''}`} role="dialog" aria-modal="true" aria-labelledby={title ? "icerik-popup-title" : undefined}>
      <div className="popup-backdrop" onClick={onClose} aria-label="Popup'u kapat"></div>
      <div className="popup-container icerik-popup">
        <button
          className="popup-close"
          onClick={onClose}
          aria-label="Popup'u kapat"
          ref={closeButtonRef}
        >
          <svg clipRule="evenodd" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#fff">
            <path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"></path>
          </svg>
        </button>
        {title && (
          <h2 id="icerik-popup-title" className="popup-title">{title}</h2>
        )}
        {content && (
          <p className="popup-description">{content}</p>
        )}
      </div>
    </div>
  );
};

export default IcerikPopup;

